import { memo, type FC, type ReactNode } from "react";

interface CustomChoicePanelProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

const CustomChoicePanel: FC<CustomChoicePanelProps> = ({ title, subtitle, children }) => (
  <div className="custom-choice-panel">
    <div className="custom-choice-panel__heading">
      <h3 className="custom-choice-panel__title">{title}</h3>
      <p className="custom-choice-panel__subtitle">{subtitle}</p>
    </div>
    {children}
  </div>
);

export default memo(CustomChoicePanel);
